<template lang="pug">
    items-list(
    class="nav-container",
    :class="{ 'is-small': small}",
    :style="styles",
    :items="items",
    :level="1",
    :max-level="maxLevel",
    :small="small"
    )

</template>

<script>
    import ItemsList from './private/List.vue'

    export default {
        components: {
            ItemsList
        },
        data() {
            return {
                startHeight: 'auto'
            }
        },
        props: {
            items: Array,
            maxLevel: {
                type: Number,
                default: 2
            },
            small: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            styles() {
                return typeof window === 'undefined' ? {} : {
                    height: this.startHeight - (this.small ? 1 : 0) + 'px'
                };
            }
        },
        mounted() {
            this.startHeight = this.$el.offsetHeight;
        }
    }
</script>

<style lang="stylus" scoped>
    .nav-container
        margin-top: -9px
        position: relative

        &::after
            content: ""
            clear: both

    .is-small
        margin-top: -8px

</style>


// WEBPACK FOOTER //
// Default.vue?92e6805e